export enum CommunityProfileAdminsEnum {
  Admin = '4160158c-b8ea-484e-347d-6ba2fd0dd0da',
  Leader = 'ad47ffaf-4c38-fc9c-aa66-14c039fadfd4',
  Volunteer = 'c5ac58f4-ecc2-42b4-b47e-7be46462e845',
}
